export const PreQualifierAssetTypeSelectionStyles = {
  loadingContainer: 'flex flex-col justify-center my-6'
}
